export default __webpack_public_path__ + "static/media/staking-import-btn.d05147d1.svg";